"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLogLevel;

var _fluxStandardAction = require("flux-standard-action");

var _get = _interopRequireDefault(require("lodash/get"));

var _logLevel = _interopRequireDefault(require("../constants/log-level"));

var _isApiError = _interopRequireDefault(require("./is-api-error"));

/**
 * Given an action, determine the logLevel to use. The log level can be set direction via the
 * `rollbar` field on an action or will automatically become a WARNING, if the payload of the action
 * is an error.
 *
 * The default log level will be INFO otherwise.
 *
 * @param {Object} action - a redux action
 */
function getLogLevel() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _action$rollbar = action.rollbar;
  _action$rollbar = _action$rollbar === void 0 ? {} : _action$rollbar;
  var _action$rollbar$logLe = _action$rollbar.logLevel,
      actionLogLevel = _action$rollbar$logLe === void 0 ? _logLevel.default.INFO : _action$rollbar$logLe;
  var isProvidedByAction = !!(0, _get.default)(action, 'rollbar.logLevel'); // return immediately if logLevel was defined on the action coming into this function

  if (isProvidedByAction) {
    return actionLogLevel;
  }

  if ((0, _fluxStandardAction.isFSA)(action) && (0, _fluxStandardAction.isError)(action)) {
    return _logLevel.default.ERROR;
  }

  if ((0, _isApiError.default)(action)) {
    return _logLevel.default.WARNING;
  }

  return actionLogLevel;
}